var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSoundOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 184,
    height: 188,
    viewBox: "0 0 184 188",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_136",
    "data-name": "Group 136",
    transform: "translate(-883 711)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-volume-up",
    "data-name": "Icon awesome-volume-up",
    d: "M61.795,16.946,36.227,42.508H6.9a6.9,6.9,0,0,0-6.9,6.9V90.788a6.9,6.9,0,0,0,6.9,6.9h29.33l25.568,25.562a6.9,6.9,0,0,0,11.774-4.877V21.823A6.9,6.9,0,0,0,61.795,16.946ZM128.846,2.267a6.954,6.954,0,0,0-7.633,11.627,67.145,67.145,0,0,1,0,112.41,6.953,6.953,0,1,0,7.633,11.624,81.054,81.054,0,0,0,0-135.662Zm9.1,67.83a53.06,53.06,0,0,0-24.648-44.9,6.868,6.868,0,0,0-9.518,2.144,6.979,6.979,0,0,0,2.129,9.587,39.276,39.276,0,0,1,0,66.338,6.978,6.978,0,0,0-2.129,9.587A6.881,6.881,0,0,0,113.293,115,53.057,53.057,0,0,0,137.941,70.1ZM97.2,48.006a6.9,6.9,0,1,0-6.656,12.087,11.327,11.327,0,0,1,0,20.007A6.9,6.9,0,1,0,97.2,92.187a25.126,25.126,0,0,0,0-44.181Z",
    transform: "translate(892 -687.098)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 184,
    height: 188,
    transform: "translate(883 -711)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundOn);
export default __webpack_public_path__ + "static/media/sound-on.ca74655b79cd742b9d1a401679ed523d.svg";
export { ForwardRef as ReactComponent };